// The two columns only a location's list adds, in the order the design puts them: the phone
// first, because it is the actionable one — the key the panel itself searches «Usuarios» by, and
// what an agent dials with a courier on the line.
//
// Local, and deliberately not folded into the shared `DELIVERY_COLUMN_HEADERS`: that array is the
// contract between this list and the «Usuario» card's, and a label added there would put two
// headers over cells the card does not render. The shared row grows its «Usuario» cells only for
// a list that hands it a titular, so the headers have to grow the same way — per list, not for
// both at once.
// TODO: i18n — copy en ES hasta Fase 1.
export const LOCATION_RECIPIENT_COLUMN_HEADERS = ['TELÉFONO USUARIO', 'NOMBRE USUARIO'];
